import { createQuery } from '@shared/lib/query-helpers';

import { syncWorkerSettingsResponseSchema, type SyncWorkerSettingsResponse } from './schemas';

export const adminSyncWorkerSettingsKeys = {
  all: ['admin-sync-worker-settings'] as const,
};

const STALE_TIME_MS = 5 * 60 * 1000;
const GC_TIME_MS = 30 * 60 * 1000;

export function adminSyncWorkerSettingsQuery() {
  return createQuery<SyncWorkerSettingsResponse>({
    queryKey: adminSyncWorkerSettingsKeys.all,
    path: '/api/v1/admin/sync-worker-settings',
    schema: syncWorkerSettingsResponseSchema,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    responseCacheTtlMs: STALE_TIME_MS,
  });
}
